<template>
  <div class="pagination-container">
    <el-pagination
      class="paging"
      background
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
      :layout="layout"
      :total="total"
      prev-text="上一页"
      next-text="下一页"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
export default {
  name: "Pagination",
  props: {
    total: {
      // 数据总条数
      required: true,
      type: Number,
    },
    page: {
      //当前页
      type: Number,
      default: 1,
    },
    limit: {
      //每页显示条目个数， 限制 每页多少条数据
      type: Number,
      default:10,
    },
    layout: {
      // 组件布局
      type: String,
      default: "total, prev,pager,next",
    },
  },
  computed: {
    currentPage: {
      get() {
        return this.page;
      },
      set(val) {
        this.$emit("update:page", val);
      },
    },
    pageSize: {
      get() {
        return this.limit;
      },
      set(val) {
        this.$emit("update:limit", val);
      },
    },
  },
  methods: {
    handleSizeChange(val) {
      this.$emit("pageChange", { page: this.currentPage, limit: val });
    },
    handleCurrentChange(val) {
      this.$emit("pageChange", { page: val, limit: this.pageSize });
    },
  },
};
</script>

<style scoped>
.el-pagination {
  text-align: center;
  margin-top: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pagination.vue